import { render, staticRenderFns } from "./dialog_investment.vue?vue&type=template&id=8e47419c&scoped=true&"
import script from "./dialog_investment.vue?vue&type=script&lang=js&"
export * from "./dialog_investment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e47419c",
  null
  
)

export default component.exports